import { type ClassValue, clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';

/**
 * Merge Tailwind utility classes while allowing conditional class values
 * (standard shadcn `cn()` helper). Used by every `ui/*` primitive.
 */
export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}

/**
 * Human-facing plugin title. Prefers the manifest `displayName` and falls
 * back to the canonical kebab-case `name` when it's absent, null, or
 * whitespace-only (the column defaults to `name`, but a manifest can set an
 * empty/blank value). Use this for every TITLE render — never for the
 * canonical `name` where it's an id / install string / slug.
 */
export function pluginTitle(plugin: { displayName: string | null; name: string }): string {
  return plugin.displayName?.trim() || plugin.name;
}
